import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import { S1, S2, S3 } from '../../../assests/ExportImageIcon'
import service from '../../../services/service'
import endpoints from '../../../services/endpoints'
import './artist.css'

// Static fallback — kept for reference. Real artists come from
// GET /customer_events/artists/ below ({ name, image }, image may be null).
// const offers = [
//     { img: S1, title: 'Flat 10% Off', subtitle: 'for student', ctaLabel: 'Book Now' },
//     { img: S2, title: 'Flat 15% Off', subtitle: 'on Manali packages', ctaLabel: 'Book Now' },
//     { img: S3, title: 'Flat 20% Off', subtitle: 'on Goa getaways', ctaLabel: 'Book Now' },
//     { img: S1, title: 'Extra ₹500 Off', subtitle: 'for armed forces', ctaLabel: 'Book Now' },
//     { img: S2, title: 'Flat 10% Off', subtitle: 'for senior citizens', ctaLabel: 'Book Now' },
//     { img: S3, title: 'Flat 12% Off', subtitle: 'on early bookings', ctaLabel: 'Book Now' },
// ]

const FALLBACK_ARTIST_IMAGES = [S1, S2, S3]

const Artist = () => {
    const navigate = useNavigate()
    const prevRef = useRef(null)
    const nextRef = useRef(null)
    const swiperRef = useRef(null)
    const [artists, setArtists] = useState([])

    useEffect(() => {
        service
            .get(endpoints.customerEvents.artists, {}, { silent: true })
            .then(({ data }) => setArtists(data.data || []))
            .catch(() => {})
    }, [])

    const offers = artists.map((artist, index) => ({
        img: artist.image || FALLBACK_ARTIST_IMAGES[index % FALLBACK_ARTIST_IMAGES.length],
        title: artist.name,
    }))

    useEffect(() => {
        const swiper = swiperRef.current
        if (!swiper) return
        swiper.params.navigation = {
            ...swiper.params.navigation,
            prevEl: prevRef.current,
            nextEl: nextRef.current,
        }
        swiper.navigation.init()
        swiper.navigation.update()
    }, [])

    return (
        <>
            <section className='specialOffer popularDestination paddingCmn'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='secHeadArea'>
                                <div className='mainHead'>Artist in your area</div>
                                <Link to="/event-list">View All</Link>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="">
                                <Swiper
                                    modules={[Navigation, Autoplay]}
                                    // spaceBetween={5}
                                    slidesPerView={1.2}
                                    loop
                                    // autoplay={{ delay: 2000, disableOnInteraction: false, pauseOnMouseEnter: true }}
                                    onSwiper={(swiper) => { swiperRef.current = swiper }}
                                    breakpoints={{
                                        576: { slidesPerView: 2 },
                                        768: { slidesPerView: 3 },
                                        992: { slidesPerView: 3 },
                                        1200: { slidesPerView: 4 },
                                    }}
                                >
                                    {offers.map((offer, index) => (
                                        <SwiperSlide key={index} className="artistSlide">
                                            <div className='artist row g-4' onClick={() => navigate(`/event-list?artist=${encodeURIComponent(offer.title)}`)}>
                                                <img src={offer.img} alt={offer.title}  />
                                                    <div className="text-center fw-bold">{offer.title}</div>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                                {/* <button type="button" className="carouselNav carouselNav-prev" ref={prevRef} aria-label="Previous">&#8249;</button>
                                <button type="button" className="carouselNav carouselNav-next" ref={nextRef} aria-label="Next">&#8250;</button> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Artist;
